// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"800ea4fe","194":"f3c66f57","216":"5d46bf8c","274":"40087f01","434":"3713a46b","555":"c86a6f41","677":"2c399844","773":"6a3c68c3","861":"a21f81cb","925":"4f2fe926","952":"98dc3bc0","986":"96c3dda0"}[chunkId] + ".chunk.js";
};